<div class="header">
	<h2>AI chats</h2>
</div>
<div class="search-header">
	<app-instant-search-box [value]="zoek.gebruikerOfInstelling$.value" (fire)="zoek.gebruikerOfInstelling$.next($event)" placeholder="Gebruiker of instelling zoeken"></app-instant-search-box>
	<app-instant-search-box [value]="zoek.onderwerp$.value" (fire)="zoek.onderwerp$.next($event)" placeholder="Onderwerp zoeken"></app-instant-search-box>
	<app-date-picker-dropdown
		[range]="zoek.dateRange$.value"
		(rangeChange)="zoek.dateRange$.next($event)"
		[view]="DateRangeView.AANGEPAST"
		placeholder="Periode selecteren"
		[allowClear]="true"
	></app-date-picker-dropdown>
	<div class="show-filter">
		<span class="label">Toon</span>
		<app-single-select-dropdown [opties]="showOptions" [selectedOptie]="getSelectedShowOption()" (onOptieClicked)="zoek.showOption$.next($event)" />
	</div>
	<div class="status-filter">
		<span class="label">Status</span>
		<app-multi-select-dropdown
			[allOptions]="statusOptions"
			[value]="zoek.status$.value"
			(valueChange)="zoek.status$.next($event)"
			placeholder="Alle statussen"
			summaryAll="Alle"
		></app-multi-select-dropdown>
	</div>
</div>
@if (aiChats$ | async; as chats) {
	<table>
		<thead>
			<tr>
				<th>Gebruiker</th>
				<th>Instelling</th>
				<th>Onderwerp</th>
				<th>Datum</th>
				<th class="tokens">Tokens</th>
				<th>Sentiment</th>
				<th>Status</th>
			</tr>
		</thead>
		<tbody>
			@for (chat of chats; track chat.id) {
				<tr (click)="gotoChat(chat)" class="clickable">
					<td>{{ getGebruiker(chat) }}</td>
					<td>{{ chat.instelling.naam }}</td>
					<td>{{ chat.onderwerp }}</td>
					<td>{{ chat.lastModified | date: "short" }}</td>
					<!-- Leeg bij conversaties van vóór CL-9132: die zijn nooit gemeten, en een 0 zou
						suggereren dat ze niets gekost hebben. -->
					<td class="tokens" [title]="chat.tokens == null ? '' : chat.tokens + ' tokens'">{{ chat.tokens | compactNumber }}</td>
					<td>
						@if (chat.sentiment !== undefined && SENTIMENT_ICON[chat.sentiment]; as icon) {
							<app-icon [name]="icon.name" [color]="icon.color" class="icon" size="small"></app-icon>
						}
					</td>
					<td>
						@if (chat.status; as status) {
							<div class="status-label" [ngClass]="status.toLowerCase()">
								{{ getAIChatConversatieStatusName(status) }}
							</div>
						}
					</td>
				</tr>
			}
		</tbody>
	</table>
}
